module.exports = __webpack_public_path__ + "static/media/ins-ld-bg-mobile-low.393d7d4c.png";